import { placeName, precisionWord, type SitePlace } from '@nsb/core';

/**
 * The line under the site (P-11): what it was picked as; Getting the place… while a Google suggestion picked is asked
 * for, or why it could not be; Searching… while a search is out for the words typed; that nothing matched them, and the
 * site is kept as typed; or nothing.
 */
export function placeLine(s: {
  place: SitePlace | null;
  unavailable: boolean;
  searching: boolean;
  pending: boolean;
  found: number | null;
  picking?: boolean;
  failed?: string | null;
}): string {
  if (s.place) return `${precisionWord(s.place.precision)} · banners will show ${placeName(s.place)}`;
  if (s.picking) return 'Getting the place…';
  if (s.failed) return s.failed;
  if (!s.searching) return '';
  if (s.pending) return 'Searching…';
  if (s.unavailable) return 'Suggestions are unavailable right now; the site is kept as typed.';
  if (s.found === 0) return 'No match found. Keep typing, or keep it as typed.';
  return '';
}
